// extracted by mini-css-extract-plugin
export default {"container":"table_container__6a1Vt","toolbar":"table_toolbar__nafDA","icon":"table_icon__0i01r","table":"table_table__OGdXL","tableContent":"table_tableContent__OO53r"};